import type { ReactNode } from "react";
import { useItandiAccountSessions } from "../hooks/useItandiAccountSessions";
import { useItandiAccountUserSessions } from "../hooks/useItandiAccountUserSessions";
import { Header } from "./Header";

type LayoutProps = {
	children: ReactNode;
};

export function Layout({ children }: LayoutProps) {
	const { data: account } = useItandiAccountSessions();
	const { data: itandiUserSession } = useItandiAccountUserSessions();
	if (account && !itandiUserSession) {
		return null;
	}
	if (account && !itandiUserSession?.user) {
		return (
			<span>
				点検管理くんの利用準備が完了していません。ユーザーの設定をしてください。
			</span>
		);
	}
	return (
		<>
			{account && itandiUserSession ? (
				<Header account={account} user={itandiUserSession} />
			) : null}
			{children}
		</>
	);
}
